import React, { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Tabs,
  Tab,
  Box,
  TextField,
  CardMedia,
  Input,
} from "@mui/material";
import EditText from "../../components/editText";
import AddFaq from "../../Modals/addFaq";
import AddIcon from "@mui/icons-material/Add";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import { showError, showToast } from "../../helpers";
import {
  useDeleteFaqMutation,
  useLazyGetCmsQuery,
  useLazyGetFAQQuery,
  useUpdateCmsMutation,
} from "../../services/cms";
import * as Yup from "yup";
import dayjs from "dayjs";
import SwitchToggle from "../../components/SwitchToggle";
import DeleteConfirmationModal from "../../components/DeleteModal";
import {
  UploadMedia,
  UploadMediaWithoutCompress,
  UploadVideo,
} from "../../utils/uploadMedia";
import {
  useAddSettingMutation,
  useLazyGetSettingsQuery,
  useUpdateSettingMutation,
} from "../../services/settings";
import usePermission from "../../hooks/userAccess";
import { isValidInput } from "../../utils/validations";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const navigate = useNavigate();
  const [getCms] = useLazyGetCmsQuery();
  const [getFaqs] = useLazyGetFAQQuery();
  const [deleteFaqs] = useDeleteFaqMutation();

  const { isView, isAdd, isDelete } = usePermission({
    label: "Manage CMS Pages",
    page_permission: "isView",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setTitle("");
    setDescription("");
    setActiveId("");
    setOpenModal(false);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [image, setImage] = useState<string>("");
  const [image2, setImage2] = useState<string>("");
  const [image3, setImage3] = useState<string>("");
  const [image4, setImage4] = useState<string>("");
  const [image5, setImage5] = useState<string>("");
  const [gif, setGif] = useState<string>("");
  const [video, setVideo] = useState<string>("");
  const [isGifActive, setIsGifActive] = useState<boolean>(false);
  const [isVideoActive, setIsVideoActive] = useState<boolean>(false);

  const [phoneDisplay, setPhoneDisplay] = React.useState("");
  const [color, setColor] = useState("#0CD0C6");
  const [updateCMS] = useUpdateCmsMutation();
  const [termsAndConditions, setTermsAndConditions] = useState<string>("");
  const [legal, setLegal] = useState<string>("");
  const [cmsId, setCmsId] = useState<string>("");
  const [gifId, setGifId] = useState<string>("");
  const [phoneCode, setPhoneCode] = useState("+91");
  const [privacyPolicy, setPrivacyPolicy] = useState<string>("");
  const [aboutUs, setAboutUs] = useState<string>("");
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [activeId, setActiveId] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [faqs, setFaqs] = useState<any[]>([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [addSettings] = useAddSettingMutation();
  const [getSettings] = useLazyGetSettingsQuery();
  const [data, setData] = useState<any>();
  const [updateSettings] = useUpdateSettingMutation();
  const [loyaltyPointValue, setLoyaltyPointValue] = useState<number>(0);
  const [settingsId, setSettingsId] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  /*api setup*/

  const getFacilities = async () => {
    try {
      const response = await getSettings({} as any).unwrap();
      if (response?.statusCode === 200) {
        setData(response?.data);
        // setIsGifActive(response?.data?.theme?.isGifActive);
        // setIsVideoActive(response?.data?.theme?.isVideoActive);
        setGifId(response?.data?.id);
        setSettingsId(response?.data?.id || "");
        // setLoyaltyPointValue(response?.data?.loyaltyPointsInAed || 0);
        console.log(response?.data, "DFFDGHFGD");
      } else {
        setData(null);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  // Settings form (Theme Settings tab)
  // const settingsFormik = useFormik({
  //   enableReinitialize: true,
  //   initialValues: {
  //     theme: {
  //       appLogo: data?.theme?.appLogo || image || "",
  //       backgroundColor: data?.theme?.backgroundColor || color || "#0CD0C6",
  //       uploadSplshImage: (
  //         data?.theme?.uploadSplshImage || [image2, image3, image4, image5]
  //       ).filter((u: string) => !!u),
  //       gifs: (data?.theme?.gifs || (gif ? [gif] : [])).filter(
  //         (u: string) => !!u
  //       ),
  //       videos: (data?.theme?.videos || (video ? [video] : [])).filter(
  //         (u: string) => !!u
  //       ),
  //     },
  //   },
  //   validationSchema: Yup.object({
  //     theme: Yup.object({
  //       appLogo: Yup.string().nullable(),
  //       backgroundColor: Yup.string().required("Background color is required"),
  //     }),
  //   }),
  //   onSubmit: async () => {
  //     const body = {
  //       theme: {
  //         appLogo: image || "",
  //         backgroundColor: color || "#0CD0C6",
  //         uploadSplshImage: [image2, image3, image4, image5].filter((u) => !!u),
  //         gifs: gif ? [gif] : [],
  //         videos: video ? [video] : [],
  //         isGifActive: !!isGifActive,
  //         isVideoActive: !!isVideoActive
  //       },
  //     } as any;

  //     try {
  //       const res = await addSettings({ body } as any).unwrap();
  //       if (res?.statusCode === 200) {
  //         showToast("Settings saved successfully");
  //         getFacilities();
  //       }
  //     } catch (error: any) {
  //       showError(error?.data?.message || "Failed to save settings");
  //     }
  //   },
  // });
  // Define types
  interface ThemeSettings {
    appLogo: string;
    backgroundColor: string;
    uploadSplshImage: string[];
    gifs: string[];
    videos: string[];
    isGifActive: boolean;
    isVideoActive: boolean;
    extraSplshImage: string[];
  }

  interface SettingsFormValues {
    theme: ThemeSettings;
  }

  // Move validation schema outside the component to prevent recreation
  const settingsValidationSchema = Yup.object({
    theme: Yup.object({
      appLogo: Yup.string().nullable(),
      backgroundColor: Yup.string().required("Background color is required"),
    }),
  });

  // In your component:
  const settingsFormik = useFormik<SettingsFormValues>({
    enableReinitialize: true,
    initialValues: {
      theme: {
        appLogo: data?.theme?.appLogo || image || "",
        backgroundColor: data?.theme?.backgroundColor || color || "#0CD0C6",
        uploadSplshImage: (
          data?.theme?.uploadSplshImage || [image2, image3, image4]
        ).filter(Boolean),
        gifs: (data?.theme?.gifs || (gif ? [gif] : [])).filter(Boolean),
        videos: (data?.theme?.videos || (video ? [video] : [])).filter(Boolean),
        isGifActive: data?.theme?.isGifActive ?? isGifActive,
        isVideoActive: data?.theme?.isVideoActive ?? isVideoActive,
        extraSplshImage: data?.theme?.extraSplshImage || [image5],
      },
    },
    validationSchema: settingsValidationSchema,
    onSubmit: async (_, { setSubmitting }) => {
      try {
        const themeData: ThemeSettings = {
          appLogo: image || "",
          backgroundColor: color || "#0CD0C6",
          uploadSplshImage: [image2, image3, image4].filter(Boolean),
          gifs: gif ? [gif] : [],
          videos: video ? [video] : [],
          isGifActive: isGifActive,
          isVideoActive: isVideoActive,
          extraSplshImage: image5 ? [image5] : [],
        };

        const response = await addSettings({
          body: { theme: themeData },
        }).unwrap();

        if (response?.statusCode === 200) {
          showToast("Settings saved successfully");
          await getFacilities();
        }
      } catch (error: any) {
        showError(error?.data?.message || "Failed to save settings");
      } finally {
        setSubmitting(false);
      }
    },
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      phone: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address"
        ),
      phone: Yup.string()
        .required("Phone number is required")
        .min(6, "Phone number must be at least 6 characters")
        .max(16, "Phone number must be at least 16 characters"),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      updateCmsContact();
    },
  });

  const buildCmsBody = () => ({
    email: formik.values.email,
    dialCode: phoneCode, // phoneCode already has + prefix from handleChangePhone
    phone: formik.values.phone,
    terms: termsAndConditions,
    privacyPolicy: privacyPolicy,
    legal: legal,
    aboutUs: aboutUs,
  });

  const updateCmsContact = async () => {
    try {
      const response = await updateCMS({
        body: buildCmsBody() as any,
        id: cmsId,
      }).unwrap();
      if (response.statusCode === 200) {
        // Show contextual toast per active tab
        if (valueTabs === 0) {
          showToast("Contact details updated successfully");
        } else if (valueTabs === 1) {
          showToast("Legal details updated successfully");
        } else if (valueTabs === 2) {
          showToast("Terms & Conditions updated successfully");
        } else if (valueTabs === 3) {
          showToast("Privacy Policy updated successfully");
        } else {
          showToast("CMS updated successfully");
        }
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await deleteFaqs({ id: activeId }).unwrap();
      if (response?.statusCode === 200) {
        toggleDeleteModal();
        setActiveId("");
        getFaqListing();
        showToast("Faq deleted successfully");
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  const getCmsData = async () => {
    setIsLoading(true);
    try {
      const response = await getCms({}).unwrap();
      if (response.statusCode == 200) {
        const countryCode = response?.data?.countryCode || "+91";
        const phoneNumber = response?.data?.phone || "";

        // Set the country code
        setPhoneCode(countryCode);

        // Set the display value for PhoneInput (this should be the full number)
        setPhoneDisplay(countryCode + phoneNumber);

        setPrivacyPolicy(response?.data?.privacyPolicy || "");
        setTermsAndConditions(response?.data?.terms || "");
        setLegal(response?.data?.legal || "");
        setCmsId(response?.data?._id || "");
        setAboutUs(response?.data.aboutUs || "");
        setLoyaltyPointValue(response?.data?.loyaltyPointsInAed || 0);
        formik.setFieldValue("email", response.data?.email || "");
        formik.setFieldValue("phone", phoneNumber); // Just the phone number without country code
        // Toggles
        // setIsGifActive(!!response?.data?.isGifActive);
        // console.log(response?.data?.isGifActive, "DAAAA");
        // setIsVideoActive(response?.data?.isVideoActive);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleChangePhone = (phone: any, country: any) => {
    // Extract the actual phone number without country code
    const phoneWithoutCountryCode = phone?.replace(country.dialCode, "");

    // Update formik field with just the phone number
    formik.setFieldValue("phone", phoneWithoutCountryCode);

    // Update country code (ensure it has + prefix)
    const countryCodeWithPlus = country?.dialCode?.startsWith("+")
      ? country.dialCode
      : `+${country.dialCode}`;
    setPhoneCode(countryCodeWithPlus);

    // Set the display value for PhoneInput (full phone number with country code)
    setPhoneDisplay(phone);
  };

  const getFaqListing = async () => {
    try {
      const response = await getFaqs({
        page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response?.statusCode === 200) {
        setFaqs(response?.data?.faqs || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const toggleDeleteModal = () => {
    setOpenDelete(!openDelete);
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target?.files?.[0];
    if (!file) return;
    if (
      !(file.type && file.type.toLowerCase().startsWith("image/")) ||
      file.type.toLowerCase() === "image/gif"
    ) {
      showError("Invalid format. Please upload a PNG or JPEG image.");
      (event.target as HTMLInputElement).value = "";
      return;
    }
    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data) {
      setImage(imageUrl.data?.image);
    }
  };

  const handleSplash1Upload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target?.files?.[0];
    if (!file) return;
    if (
      !(file.type && file.type.toLowerCase().startsWith("image/")) ||
      file.type.toLowerCase() === "image/gif"
    ) {
      showError("Invalid format. Please upload a PNG or JPEG image.");
      (event.target as HTMLInputElement).value = "";
      return;
    }
    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data) {
      setImage2(imageUrl.data?.image);
    }
  };

  const handleSplash2Upload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target?.files?.[0];
    if (!file) return;
    if (
      !(file.type && file.type.toLowerCase().startsWith("image/")) ||
      file.type.toLowerCase() === "image/gif"
    ) {
      showError("Invalid format. Please upload a PNG or JPEG image.");
      (event.target as HTMLInputElement).value = "";
      return;
    }
    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data) {
      setImage3(imageUrl.data?.image);
    }
  };

  const handleSplash3Upload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target?.files?.[0];
    if (!file) return;
    if (
      !(file.type && file.type.toLowerCase().startsWith("image/")) ||
      file.type.toLowerCase() === "image/gif"
    ) {
      showError("Invalid format. Please upload a PNG or JPEG image.");
      (event.target as HTMLInputElement).value = "";
      return;
    }
    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data) {
      setImage4(imageUrl.data?.image);
    }
  };

  const handleSplash4Upload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target?.files?.[0];
    console.log(file, "--------------------file");
    if (!file) return;
    if (
      !(file.type && file.type.toLowerCase().startsWith("image/")) ||
      file.type.toLowerCase() === "image/gif"
    ) {
      showError("Invalid format. Please upload a PNG or JPEG image.");
      (event.target as HTMLInputElement).value = "";
      return;
    }
    const imageUrl = (await UploadMedia(file)) as any;
    console.log(imageUrl, "--------------------file");
    if (imageUrl?.data) {
      setImage5(imageUrl.data?.image);
    }
  };

  const handleGifUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target?.files?.[0];
    if (!file) return;
    if (!(file.type && file.type.toLowerCase() === "image/gif")) {
      showError("Invalid format. Please upload a GIF file (.gif).");
      (event.target as HTMLInputElement).value = "";
      return;
    }

    const imageUrl = (await UploadMediaWithoutCompress(file)) as any;
    if (imageUrl?.data) {
      setGif(imageUrl.data?.image);
    }
  };

  const handleVideoUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target?.files?.[0];
    console.log(file, "------------file");
    if (!file) return;
    if (!(file.type && file.type.toLowerCase().startsWith("video/"))) {
      showError("Invalid format. Please upload a video file.");
      (event.target as HTMLInputElement).value = "";
      return;
    }
    const uploadRes = (await UploadVideo(file)) as any;
    if (uploadRes?.data) {
      setVideo(uploadRes.data?.image);
    }
  };

  useEffect(() => {
    getCmsData();
    getFacilities();
  }, []);

  // Reset page to 0 when search term changes
  useEffect(() => {
    setPage(0);
  }, [debouncedSearchTerm]);

  // Trigger search when debouncedSearchTerm or page changes
  useEffect(() => {
    getFaqListing();
  }, [debouncedSearchTerm, page]);

  // When settings data is fetched, reflect into local UI states so previews are populated
  useEffect(() => {
    if (!data) return;
    setImage(data?.theme?.appLogo || "");
    setColor(data?.theme?.backgroundColor || "#0CD0C6");
    const splash: string[] = Array.isArray(data?.theme?.uploadSplshImage)
      ? data.theme.uploadSplshImage
      : [];
    const extraSplshImage: string[] = Array.isArray(
      data?.theme?.extraSplshImage
    )
      ? data.theme.extraSplshImage
      : [];
    setImage2(splash[0] || "");
    setImage3(splash[1] || "");
    setImage4(splash[2] || "");
    setImage5(extraSplshImage[0] || "");
    const gifsArr: string[] = Array.isArray(data?.theme?.gifs)
      ? data.theme.gifs
      : [];
    setGif(gifsArr[0] || "");
    const videosArr: string[] = Array.isArray(data?.theme?.videos)
      ? data.theme.videos
      : [];
    setVideo(videosArr[0] || "");
    // If settings also include these flags
    // if (typeof (data as any)?.isGifActive === "boolean")
    setIsGifActive(data?.theme?.isGifActive);
    // if (typeof (data as any)?.isVideoActive === "boolean")
    setIsVideoActive(data?.theme?.isVideoActive);
    // Set loyalty point value
    if (data?.loyaltyPointsInAed !== undefined) {
      setLoyaltyPointValue(data.loyaltyPointsInAed);
    }
  }, [data]);

  const handleToggleGif = async (checked: boolean) => {
    try {
      await addSettings({
        body: { theme: { isGifActive: checked } } as any,
      }).unwrap();
      setIsGifActive(checked);
      showToast(`GIF ${checked ? "enabled" : "disabled"} successfully`);
    } catch (error: any) {
      showError(error?.data?.message || "Failed to update GIF status");
    }
  };

  const handleToggleVideo = async (checked: boolean) => {
    try {
      await addSettings({
        body: { theme: { isVideoActive: checked } } as any,
      }).unwrap();
      setIsVideoActive(checked);
      showToast(`Video ${checked ? "enabled" : "disabled"} successfully`);
    } catch (error: any) {
      showError(error?.data?.message || "Failed to update Video status");
    }
  };

  // Loyalty Points form
  const loyaltyPointsFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      loyaltyPointValue: loyaltyPointValue || 0,
    },
    validationSchema: Yup.object({
      loyaltyPointValue: Yup.number()
        .required("Loyalty point value is required")
        .min(0, "Loyalty point value must be greater than or equal to 0")
        .integer("Loyalty point value must be an integer"),
    }),
    onSubmit: async (values) => {
      setLoyaltyPointValue(Number(values.loyaltyPointValue));
      try {
        await updateCMS({
          body: { loyaltyPointsInAed: values.loyaltyPointValue } as any,
          id: cmsId,
        }).unwrap();
        showToast("Loyalty point value saved");
      } catch (error: any) {
        showError(
          error?.data?.message || "Failed to update loyalty point value"
        );
      }
    },
  });

  return (
    <>
      <div className="main_title">
        <h1>Manage CMS</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage CMS
        </p>
      </div>

      {isView && (
        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Contact Support" {...a11yProps(0)} />
                {/* <Tab label="Legal" {...a11yProps(1)} /> */}
                <Tab label="Terms & Conditions" {...a11yProps(1)} />
                <Tab label="Privacy Policy" {...a11yProps(2)} />
                <Tab label="FAQ's" {...a11yProps(3)} />
                <Tab label="Theme  Settings" {...a11yProps(4)} />
                <Tab label="Loyalty Point" {...a11yProps(5)} />
              </Tabs>
            </Box>
          </div>
        </div>
      )}

      {isView && (
        <div className="cards">
          <CustomTabPanel value={valueTabs} index={0}>
            <form className="form" onSubmit={formik.handleSubmit}>
              <div className="gap_p">
                <div className="control_group w_50">
                  <label htmlFor="email">Email Address</label>
                  <TextField
                    hiddenLabel
                    className="text_field"
                    type={"email"}
                    name="email"
                    variant="outlined"
                    fullWidth
                    value={formik.values.email}
                    onChange={(e) => {
                      if (e.target.value == " ") return;
                      if (e.target.value.length <= 50) formik.handleChange(e);
                      else showError("Email can't exceed 50 characters");
                    }}
                    onBlur={formik.handleBlur}
                    helperText={formik.touched.email && formik.errors.email}
                    placeholder="Email"
                  />
                </div>
                <div className="control_group w_50">
                  <label htmlFor="phone">Phone Number</label>
                  <PhoneInput
                    country={"us"}
                    placeholder="0 (000) 000-000"
                    enableSearch={true}
                    value={phoneDisplay}
                    onChange={handleChangePhone}
                    inputStyle={{ width: "100%" }}
                    // Add these props for better functionality:
                    countryCodeEditable={false}
                    specialLabel=""
                  />
                  {formik.touched.phone && formik.errors.phone ? (
                    <h6 className="err_msg">
                      {formik.touched.phone && formik.errors.phone}
                    </h6>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {isAdd && (
                <div className="form_btn">
                  <Button
                    className="btn btn_primary"
                    type="submit"
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    Save
                  </Button>
                </div>
              )}
            </form>
          </CustomTabPanel>
          {/* <CustomTabPanel value={valueTabs} index={1}>
            <EditText content={legal} setContent={setLegal} />
            {isAdd && (
              <div className="form_btn">
                <Button className="btn btn_primary" onClick={updateCmsContact}>
                  Save
                </Button>
              </div>
            )}
          </CustomTabPanel> */}
          <CustomTabPanel value={valueTabs} index={1}>
            <EditText
              content={termsAndConditions}
              setContent={setTermsAndConditions}
            />
            {isAdd && (
              <div className="form_btn">
                <Button className="btn btn_primary" onClick={updateCmsContact}>
                  Save
                </Button>
              </div>
            )}
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={2}>
            <EditText content={privacyPolicy} setContent={setPrivacyPolicy} />
            {isAdd && (
              <div className="form_btn">
                <Button className="btn btn_primary" onClick={updateCmsContact}>
                  Save
                </Button>
              </div>
            )}
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={3}>
            <div className="table_header">
              <div className="left_s">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search..."
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => {
                    setSearchTerm("");
                    setDebouncedSearchTerm("");
                  }}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </div>
              {isAdd && (
                <div className="right_s">
                  <Button
                    className="btn btn_primary"
                    onClick={() => {
                      setIsEdit(false);
                      setActiveId("");
                      setTitle("");
                      setDescription("");
                      setOpenModal(true);
                    }}
                  >
                    <AddIcon /> Add FAQ
                  </Button>
                </div>
              )}
            </div>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow hover>
                    <TableCell>Sr.no</TableCell>
                    <TableCell>Question</TableCell>
                    <TableCell>Answer</TableCell>
                    <TableCell>Created Date</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {faqs?.map((data, index) => (
                    <TableRow hover key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{data?.question || ""}</TableCell>
                      <TableCell className="max_c2">
                        <p>{data?.answer || ""}</p>
                      </TableCell>
                      <TableCell>
                        {dayjs(data?.createdAt || "").format("DD MMM YYYY")}
                      </TableCell>
                      {/* <TableCell>12 Jan 2024</TableCell> */}
                      <TableCell>
                        <div className="table_actions v2">
                          {isEdit && (
                            <IconButton
                              onClick={() => {
                                setTitle(data?.question || "");
                                setDescription(data?.answer || "");
                                setActiveId(data?._id || "");
                                setOpenModal(true);
                              }}
                            >
                              <img src="/static/images/edit2_icon.svg" alt="" />
                            </IconButton>
                          )}
                          {isDelete && (
                            <IconButton
                              onClick={() => {
                                setActiveId(data?._id || "");
                                toggleDeleteModal();
                              }}
                            >
                              <img
                                src="/static/images/trash2_icon.svg"
                                alt=""
                              />
                            </IconButton>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={4}>
            <form className="form" onSubmit={settingsFormik.handleSubmit}>
              <div className="gap_p">
                <div className="control_group">
                  <div className="gap_">
                    <div className="control_group w_100">
                      <label>Upload Image</label>
                      <p
                        style={{
                          fontSize: "12px",
                          color: "#666",
                          marginTop: "5px",
                          marginBottom: "8px",
                          fontWeight: "normal",
                        }}
                      >
                        For better visualization please add images in: 1080 ×
                        1080 px to 1920 × 1080 px
                      </p>
                      {image ? (
                        <div className="upload_image">
                          <div className="upload_image_holder">
                            <figure>
                              <CardMedia
                                component="img"
                                image={image}
                                alt="Banner"
                              />
                            </figure>
                            <CloseIcon
                              onClick={() => {
                                setImage("");
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <label
                          className="upload_image"
                          htmlFor="icon-button-file"
                        >
                          <Input
                            id="icon-button-file"
                            type="file"
                            sx={{ display: "none" }}
                            inputProps={{ accept: "image/png,image/jpeg" }}
                            onChange={(event) => {
                              handleImageUpload(event as any);
                              event.target.value = "";
                            }}
                          />
                          <span className="upload_image_holder">
                            <figure className="add_img">
                              <img
                                src="/static/images/placeholder.png"
                                alt="icon"
                              />
                              <span className="upload_img_icon">
                                <img
                                  src="/static/images/edit2_icon.svg"
                                  alt="edit"
                                />
                              </span>
                            </figure>
                          </span>
                        </label>
                      )}
                    </div>
                  </div>
                </div>
                <div className="control_group  w_50">
                  <label htmlFor="email">Background Color</label>
                  <div className="color_value">
                    <TextField
                      type="color"
                      placeholder="Enter here"
                      value={color}
                      onChange={(e) => setColor(e.target.value)}
                      fullWidth
                      hiddenLabel
                    />
                    <p>{color}</p>
                  </div>
                </div>
              </div>
              <div className="section_title subTitle">
                <h2>Upload Splash Images</h2>
              </div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#666",
                  marginTop: "5px",
                  marginBottom: "8px",
                  fontWeight: "normal",
                }}
              >
                For better visualization please add images in: 1080 × 1080 px to
                1920 × 1080 px
              </p>
              <div className="gap_">
                <div className="control_group w_100">
                  <label htmlFor="icon-button-file"> Images</label>
                  <div className="gap_p">
                    <div className="control_group w_33">
                      {image2 ? (
                        <div className="upload_image v2 no_radius">
                          <div className="upload_image_holder">
                            <figure>
                              <CardMedia
                                component="img"
                                image={image2}
                                alt="Uploaded profile photo"
                              />
                            </figure>
                            <IconButton
                              aria-label="Remove uploaded image"
                              onClick={() => {
                                setImage2("");
                              }}
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </div>
                        </div>
                      ) : (
                        <label
                          className="upload_image v2  no_radius"
                          htmlFor="splash1-file"
                        >
                          <Input
                            id="splash1-file"
                            type="file"
                            sx={{ display: "none" }}
                            inputProps={{ accept: "image/png,image/jpeg" }}
                            onChange={(event) => {
                              handleSplash1Upload(event as any);
                              (event.target as HTMLInputElement).value = "";
                            }}
                          />
                          <span className="upload_image_holder">
                            <figure className="add_img">
                              <img
                                src="/static/images/placeholder.png"
                                alt="icon"
                              />
                              <span className="upload_img_icon">
                                <img
                                  src="/static/images/edit2_icon.svg"
                                  alt="edit"
                                />
                              </span>
                            </figure>
                          </span>
                        </label>
                      )}
                    </div>
                    <div className="control_group w_33">
                      {image3 ? (
                        <div className="upload_image v2 no_radius">
                          <div className="upload_image_holder">
                            <figure>
                              <CardMedia
                                component="img"
                                image={image3}
                                alt="Uploaded profile photo"
                              />
                            </figure>
                            <IconButton
                              aria-label="Remove uploaded image"
                              onClick={() => {
                                setImage3("");
                              }}
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </div>
                        </div>
                      ) : (
                        <label
                          className="upload_image v2  no_radius"
                          htmlFor="splash2-file"
                        >
                          <Input
                            sx={{ display: "none" }}
                            id="splash2-file"
                            type="file"
                            inputProps={{ accept: "image/png,image/jpeg" }}
                            onChange={(event) => {
                              handleSplash2Upload(event as any);
                              (event.target as HTMLInputElement).value = "";
                            }}
                          />
                          <span className="upload_image_holder">
                            <figure className="add_img">
                              <img
                                src="/static/images/placeholder.png"
                                alt="placeholder"
                              />
                              <span className="upload_img_icon">
                                <img
                                  src="/static/images/edit2_icon.svg"
                                  alt="Upload"
                                />
                              </span>
                            </figure>
                          </span>
                        </label>
                      )}
                    </div>
                    <div className="control_group w_33">
                      {image4 ? (
                        <div className="upload_image v2 no_radius">
                          <div className="upload_image_holder">
                            <figure>
                              <CardMedia
                                component="img"
                                image={image4}
                                alt="Uploaded profile photo"
                              />
                            </figure>
                            <IconButton
                              aria-label="Remove uploaded image"
                              onClick={() => {
                                setImage4("");
                              }}
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </div>
                        </div>
                      ) : (
                        <label
                          className="upload_image v2  no_radius"
                          htmlFor="splash3-file"
                        >
                          <Input
                            sx={{ display: "none" }}
                            id="splash3-file"
                            type="file"
                            inputProps={{ accept: "image/png,image/jpeg" }}
                            onChange={(event) => {
                              handleSplash3Upload(event as any);
                              (event.target as HTMLInputElement).value = "";
                            }}
                          />
                          <span className="upload_image_holder">
                            <figure className="add_img">
                              <img
                                src="/static/images/placeholder.png"
                                alt="placeholder"
                              />
                              <span className="upload_img_icon">
                                <img
                                  src="/static/images/edit2_icon.svg"
                                  alt="Upload"
                                />
                              </span>
                            </figure>
                          </span>
                        </label>
                      )}
                    </div>
                    <div className="control_group w_33">
                      <label htmlFor="icon-button-file">
                        {" "}
                        Extra Splash Image
                      </label>
                      {image5 ? (
                        <div className="upload_image v2 no_radius">
                          <div className="upload_image_holder">
                            <figure>
                              <CardMedia
                                component="img"
                                image={image5}
                                alt="Uploaded profile photo"
                              />
                            </figure>
                            <IconButton
                              aria-label="Remove uploaded image"
                              onClick={() => {
                                setImage5("");
                              }}
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </div>
                        </div>
                      ) : (
                        <label
                          className="upload_image v2  no_radius"
                          htmlFor="splash4-file"
                        >
                          <Input
                            sx={{ display: "none" }}
                            id="splash4-file"
                            type="file"
                            inputProps={{ accept: "image/png,image/jpeg" }}
                            onChange={(event) => {
                              handleSplash4Upload(event as any);
                              (event.target as HTMLInputElement).value = "";
                            }}
                          />
                          <span className="upload_image_holder">
                            <figure className="add_img">
                              <img
                                src="/static/images/placeholder.png"
                                alt="placeholder"
                              />
                              <span className="upload_img_icon">
                                <img
                                  src="/static/images/edit2_icon.svg"
                                  alt="Upload"
                                />
                              </span>
                            </figure>
                          </span>
                        </label>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="section_title subTitle">
                <h2>Upload GIF & Video</h2>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "5px",
                    marginBottom: "8px",
                    fontWeight: "normal",
                    lineHeight: "1.4",
                  }}
                >
                  <div>Recommended dimensions:</div>
                  <div>• Videos: 1920 × 1080 px (16:9)</div>
                </div>
              </div>
              <div className="gap_">
                <div className="control_group w_100">
                  <div className="gap_p">
                    <div className="control_group w_33 ">
                      <label htmlFor="icon-button-file" className="flex">
                        {" "}
                        <span> Gif</span>
                        <SwitchToggle
                          checked={isGifActive}
                          onChange={(checked) => handleToggleGif(checked)}
                        />{" "}
                      </label>
                      {gif ? (
                        <div className="upload_image v2 no_radius video-container_hight">
                          <div className="upload_image_holder">
                            <figure>
                              <CardMedia
                                component="img"
                                image={gif}
                                alt="Uploaded profile photo"
                              />
                            </figure>
                            <IconButton
                              className="IconButton_style"
                              aria-label="Remove uploaded image"
                              onClick={() => {
                                setGif("");
                              }}
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </div>
                        </div>
                      ) : (
                        <label
                          className="upload_image v2  no_radius video-container_hight"
                          htmlFor="gif-file"
                        >
                          <Input
                            sx={{}}
                            id="gif-file"
                            type="file"
                            inputProps={{ accept: "image/gif,.gif" }}
                            onChange={(event) => {
                              handleGifUpload(event as any);
                              (event.target as HTMLInputElement).value = "";
                            }}
                          />
                          <span className="upload_image_holder figure_class">
                            <figure className="add_img">
                              <img
                                src="/static/images/placeholder.png"
                                alt="placeholder"
                              />
                              <span className="upload_img_icon">
                                <img
                                  src="/static/images/edit2_icon.svg"
                                  alt="Upload"
                                />
                              </span>
                            </figure>
                          </span>
                        </label>
                      )}
                    </div>
                    <div className="control_group w_33">
                      <label htmlFor="video-file" className="flex">
                        {" "}
                        <span> Video</span>
                        <SwitchToggle
                          checked={isVideoActive}
                          onChange={(checked) => handleToggleVideo(checked)}
                        />{" "}
                      </label>
                      {video ? (
                        <div className="upload_image v2 no_radius video-container_hight">
                          <div className="upload_image_holder">
                            <figure>
                              <CardMedia
                                component="video"
                                src={video}
                                controls
                                title="Description of the video"
                              />
                            </figure>
                            <IconButton
                              className="IconButton_style"
                              aria-label="Remove uploaded image"
                              onClick={() => {
                                setVideo("");
                              }}
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </div>
                        </div>
                      ) : (
                        <label
                          className="upload_image v2  no_radius video-container_hight"
                          htmlFor="video-file"
                        >
                          <Input
                            sx={{ display: "none" }}
                            id="video-file"
                            type="file"
                            inputProps={{
                              accept:
                                "video/*,video/mp4,video/webm,video/quicktime",
                            }}
                            onChange={(event) => {
                              handleVideoUpload(event as any);
                              (event.target as HTMLInputElement).value = "";
                            }}
                          />
                          <span className="upload_image_holder figure_class">
                            <figure className="add_img">
                              <img
                                src="/static/images/placeholder.png"
                                alt="placeholder"
                              />
                              <span className="upload_img_icon">
                                <img
                                  src="/static/images/edit2_icon.svg"
                                  alt="Upload"
                                />
                              </span>
                            </figure>
                          </span>
                        </label>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {isAdd && (
                <div className="btn_flex">
                  <Button className="btn btn_primary" type="submit">
                    Submit
                  </Button>
                </div>
              )}
            </form>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={5}>
            <form className="form" onSubmit={loyaltyPointsFormik.handleSubmit}>
              <div className="gap_p">
                <div className="control_group w_50">
                  <label htmlFor="loyaltyPointValue">
                    Loyalty Point Value (in AED)
                  </label>
                  <TextField
                    hiddenLabel
                    className="text_field"
                    type="text"
                    name="loyaltyPointValue"
                    variant="outlined"
                    fullWidth
                    value={loyaltyPointsFormik.values.loyaltyPointValue}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (
                        value === "" ||
                        (!isNaN(Number(value)) && Number(value) >= 0)
                      ) {
                        loyaltyPointsFormik.setFieldValue(
                          "loyaltyPointValue",
                          value === "" ? "" : Number(value)
                        );
                      }
                    }}
                    onBlur={loyaltyPointsFormik.handleBlur}
                    error={
                      loyaltyPointsFormik.touched.loyaltyPointValue &&
                      !!loyaltyPointsFormik.errors.loyaltyPointValue
                    }
                    helperText={
                      loyaltyPointsFormik.touched.loyaltyPointValue &&
                      loyaltyPointsFormik.errors.loyaltyPointValue
                    }
                    placeholder="Enter amount in AED"
                    inputProps={{ min: 0, step: 1 }}
                  />
                </div>
              </div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#666",
                  marginTop: "5px",
                  marginBottom: "8px",
                  fontWeight: "normal",
                }}
              >
                Define the static value for loyalty points. This value will
                remain constant unless updated.
              </p>
              {isAdd && (
                <div className="form_btn">
                  <Button
                    className="btn btn_primary"
                    type="submit"
                    disabled={
                      loyaltyPointsFormik.isSubmitting ||
                      !loyaltyPointsFormik.isValid
                    }
                  >
                    Save
                  </Button>
                </div>
              )}
            </form>
          </CustomTabPanel>
        </div>
      )}

      <DeleteConfirmationModal
        open={openDelete}
        onClose={toggleDeleteModal}
        handleDelete={handleDelete}
        header="Are you sure you want to delete "
      />

      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        onSuccess={getFaqListing}
        setOpen={setOpenModal}
        activeId={activeId}
        title={title}
        description={description}
      />
    </>
  );
};

export default ManageCms;
